var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.$store.state.printing && _setup.extra?.report_id)?_c('b-link',{on:{"click":function($event){return _vm.$router.push({name: 'report-run', params: {id: _setup.extra.report_id}, query: _setup.extra.params})}}},[_vm._v(_vm._s(_setup.v))]):_c('div',[_vm._v(_vm._s(_setup.v))])
}
var staticRenderFns = []

export { render, staticRenderFns }